import { get, post, put, Delete } from "../axios";

// 课程管理-列表
export const courseInfoList = (params) =>
  get("/web/course/info/list", params);

// 课程管理-新增
export const courseInfoAdd = (params) =>
  post("/web/course/info/add", params);

// 课程管理-编辑
export const courseInfoUpdate = (params) =>
  put("/web/course/info/update", params);

// 课程管理-删除
export const courseInfoDelete = (id) =>
  Delete("/web/course/info/delete/" + id, "");

// 课程管理-状态编辑
export const courseInfoStateUpdate = (params) =>
  put("/web/course/info/state/update", params);

// 课程管理-推荐首页编辑
export const courseInfoHomeUpdate = (params) =>
  put("/web/course/info/home/update", params);

// 课程管理-批量下架
export const courseInfoStateBatchUpdate = (params) =>
  put("/web/course/info/state/batchUpdate", params);

// 课程管理-精品状态编辑
export const courseInfoFeaturedUpdate = (params) =>
  put("/web/course/info/featured/update", params);

// 课程管理-全部数据
export const courseInfoListAll = () =>
  get("/web/course/info/listAll");

// 课程管理-详情
export const courseInfoDetail = (id) =>
  get("/web/course/info/view/" + id);
